<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <b-card>
        <b-row>
          <b-col sm="6" md="3" xl="3">
            <b-form-group>
              <label for="start_date" class="fs-5 fw-semibold d-inline"> Fecha inicio </label>
              <flat-pickr id="start_date" v-model="startDate" class="form-control" />
            </b-form-group>
          </b-col>
          <b-col sm="6" md="3" xl="3">
            <b-form-group>
              <label for="endDate" class="fs-5 fw-semibold d-inline"> Fecha Final </label>
              <flat-pickr id="endDate" v-model="endDate" class="form-control" />
            </b-form-group>
          </b-col>
          <b-col sm="6" md="3" xl="3">
            <b-form-group label="Tienda Origen" label-for="storeOrigin">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="locals"
                label="name"
                :reduce="(locals) => locals.id"
                input-id="storeOrigin"
                v-model="local"
              />
            </b-form-group>
          </b-col>
          <b-col m="6" md="3" xl="3">
            <b-form-group label="Filtro 2" label-for="filtro2">
              <b-form-input
                id="filtro2"
                placeholder="Filtro 2"
                autofocus
                trim
                v-model="filtro2"
              />
            </b-form-group>
          </b-col>
          <b-col m="6" md="3" xl="3">
            <b-form-group label="Filtro 3" label-for="filtro3">
              <b-form-input
                id="filtro3"
                placeholder="Filtro 3"
                trim
                v-model="filtro3"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6" md="3" xl="3">
            <b-form-group label="Acciones" label-for="actions" class="text-05">
              <div class="d-flex justify-content-around" id="actions">
                <b-button
                  @click.prevent="searchReport"
                  class="w-100"
                  id="search"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                >
                  <span class="align-middle">Buscar</span>
                </b-button>
                <b-button
                  class="w-100 ml-1"
                  @click="exportExcel"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                >
                  <span class="align-middle">Excel</span>
                </b-button>
              </div>
            </b-form-group>
          </b-col>          
        </b-row>
      </b-card>
      <!-- <ventas-filters /> -->
      <b-card no-body class="">
        <b-table
          class="position-relative shadow-md"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
          @sort-changed="sortChanged"
        >
          <template #cell(id)="{ item, field: { key }, index }">
            <span>{{ index + 1 }}</span>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span> {{ totalElements }} Registros en total</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { $themeColors } from '@themeConfig'
import VueApexCharts from 'vue-apexcharts'
import flatPickr from 'vue-flatpickr-component'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import StoreService from '@/services/StoresService'
import ReportService from '@/services/ReportsService'
import vSelect from 'vue-select'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  components: {
    VueApexCharts,
    flatPickr,
    vSelect
  },
  data() {
    return {
      showLoading: false,
      date: new Date(),
      startDate: new Date(),
      endDate: new Date(),
      totalAmount: 0.0,
      rangePicker: ['2019-05-01', '2019-05-10'],
      records: [],
      fields: [
        { key: 'id', label: 'Nº', sortable: false },
        { key: 'autopart_originalCode', label: 'Cod. Original', sortable: false },
        { key: 'autopart_alterCode', label: 'Cod. Alter.', sortable: false },
        { key: 'autopart_description', label: 'Descripción', sortable: false },
        { key: 'autopartBrand_name', label: 'Marca', sortable: false },
        { key: 'vehicleModel_model', label: 'Modelo', sortable: false },
        { key: 'qtyTotal', label: 'Stock', sortable: false },
        { key: 'qtyTotalAvailable', label: 'Cant. Dispo.', sortable: false }
      ],
      filtro2: '',
      filtro3: '',
      locals: [],
      local: 1,
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      id: 0,
      sort: 'id',
      order: 'desc'
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    cambioPagina(e) {
      this.currentPage = e
    },
    changeSizePage() {},
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    },
    async getData() {
      this.locals = []
      const resp = await StoreService.getStores('',this.$store)
      console.log('resp', resp)
      if (resp) {
        this.locals = resp.stores
        // this.locals.unshift({
        //   id: 0,
        //   name: 'Todos'
        // })
      }
    },
    async searchReport() {
      this.records = []
      // if (this.local != null) {
      //   let url = '?fi=' + this.local + '&'
      //   console.log('url', url)
      //   const respReport = await ReportService.reportProducts(url, this.$store)
      //   if (respReport.stocks.length != 0) {
      //     this.records = respReport.stocks
      //   }
      // }
      if (this.local != null) {
        let url = '?filter=' + this.local + '&filter2&filter3'
        const respReport = await ReportService.reportProducts(url, this.$store)
        if (respReport.stocks.length != 0) {
          this.records = respReport.stocks
          this.totalElements = respReport.qtyRecords
        }
      }
    },
    async exportExcel() {
      if (this.local != null) {
        let url = ''
        console.log('url', url)
        const respReport = await ReportService.reportAutoPartsExcel(url, this.$store)
        const url1 = window.URL.createObjectURL(respReport)
        const link = document.createElement('a')
        link.href = url1
        link.setAttribute('download', 'reporte.xlsx')
        document.body.appendChild(link)
        link.click()
      }
    }
  }
}
</script>

<style lang="scss">
.bg-red {
  background-color: #b2a6a6;
  color: #fff;
}
.py-05 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.text-05 {
  font-size: 0.85rem;
}
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
